import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Policies.css';

const ContentPolicy: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className="policy-container">
            <button className="back-button" onClick={() => navigate(-1)}>
                ← Back
            </button>
            <h1>Content Policy</h1>
            <p className="policy-intro">Last Updated: January 5, 2025</p>

            <section className="content-section">
                <h2 className="section-title">User-Generated Content</h2>

                <div className="content-block">
                    <ul className="list">
                        <li>Authentic: No fake profiles or impersonations.</li>
                        <li>Respectful: Free from hate speech, harassment, or explicit material.</li>
                        <li>Relevant: Used solely for dating and relationship purposes.</li>
                    </ul>
                </div>

                <h2 className="section-title">Prohibited Content</h2>
                <div className="content-block">
                    <ul className="list">
                        <li>Nudity or sexually explicit images (including overly suggestive poses).</li>
                        <li>Violent content, threats, or content glorifying illegal activities.</li>
                        <li>Misinformation, scams, or spam.</li>
                        <li>Any form of hate speech, racism, sexism, or discriminatory content.</li>
                    </ul>
                    <p>
                        Violation of these guidelines may result in immediate account suspension or permanent banning,
                        along with potential legal consequences.
                    </p>
                </div>
            </section>

            {/* Updates to These Policies Section */}
            <section className="updates-section">
                <h2 className="section-title">Updates to These Policies</h2>

                <div className="content-block">
                    <p>
                        We reserve the right to update these policies at any time.
                    </p>
                    <ul className="list">
                        <li>Significant changes will be communicated to users via the app and/or email.</li>
                        <li>Continued use of Fervoir after changes constitutes acceptance of the new policies.</li>
                    </ul>
                </div>
            </section>

            {/* Contact Section */}
            <section className="contact-section">
                <h2 className="section-title">Contact Us</h2>
                <div className="content-block">
                    <p>For any questions, concerns, or feedback, please contact us at:</p>
                    <p>
                        Email: <a href="mailto:paulfortuneltd@gmail.com" className="email">paulfortuneltd@gmail.com</a>
                    </p>
                </div>
            </section>
        </div>
    );
};

export default ContentPolicy;